module.exports = {
	"ha": "iha",
	"id": 5.4,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.4</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Interior Health by MSM Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -125,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 96.78899082568807,
						"dataLabels": {
							"enabled": true,
							"format": "211"
						}
					},
					{
						"y": 89.44954128440367,
						"dataLabels": {
							"enabled": true,
							"format": "195"
						}
					},
					{
						"y": 87.1559633027523,
						"dataLabels": {
							"enabled": true,
							"format": "190"
						}
					},
					{
						"y": 82.11009174311926,
						"dataLabels": {
							"enabled": true,
							"format": "179"
						}
					},
					{
						"y": 60.09174311926605,
						"dataLabels": {
							"enabled": true,
							"format": "131"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.0464135021097,
						"dataLabels": {
							"enabled": true,
							"format": "230"
						}
					},
					{
						"y": 83.96624472573839,
						"dataLabels": {
							"enabled": true,
							"format": "199"
						}
					},
					{
						"y": 80.59071729957806,
						"dataLabels": {
							"enabled": true,
							"format": "191"
						}
					},
					{
						"y": 70.88607594936708,
						"dataLabels": {
							"enabled": true,
							"format": "168"
						}
					},
					{
						"y": 54.85232067510548,
						"dataLabels": {
							"enabled": true,
							"format": "130"
						}
					},
					{
						"y": null
					},
					{
						"y": 93.36492890995261,
						"dataLabels": {
							"enabled": true,
							"format": "197"
						}
					},
					{
						"y": 70.14218009478674,
						"dataLabels": {
							"enabled": true,
							"format": "148"
						}
					},
					{
						"y": 66.82464454976304,
						"dataLabels": {
							"enabled": true,
							"format": "141"
						}
					},
					{
						"y": 61.137440758293835,
						"dataLabels": {
							"enabled": true,
							"format": "129"
						}
					},
					{
						"y": 44.07582938388626,
						"dataLabels": {
							"enabled": true,
							"format": "93"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -3.2110091743119296,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.5829383886255926,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.564102564102566,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.789473684210522,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.815642458100562,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.9535864978902926,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.478260869565217,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.020100502512558,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.041884816753923,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.619047619047617,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -6.635071090047395,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.873096446700504,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.729729729729726,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.510638297872342,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.906976744186053,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "MSM<br>n=218"
			},
			{
				"x": 9,
				"text": "Non-MSM<br>n=237"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=211"
			}
		],
		"dataTable": {
			"MSM": [
				218,
				211,
				195,
				190,
				179,
				131
			],
			"Non-MSM": [
				237,
				230,
				199,
				191,
				168,
				130
			],
			"Unknown": [
				211,
				197,
				148,
				141,
				129,
				93
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_4.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_iha_5_4.json
// module id = 237
// module chunks = 0